import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

export const QRScanner = ({ onScan }) => {

  const qrRef = useRef(null);
  const [cameras, setCameras] = useState([]);
  const [currentCamera, setCurrentCamera] = useState(null);
  const [cameraMode, setCameraMode] = useState("environment");
  const [isRunning, setIsRunning] = useState(false);
  const [loadingCamera, setLoadingCamera] = useState(true);
  const hasScanned = useRef(false);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  useEffect(() => {
    const initCamera = async () => {
      try {
        const devices = await Html5Qrcode.getCameras();

        if (devices && devices.length) {
          setCameras(devices);

          const back = devices.find(d =>
            d.label.toLowerCase().includes("back") ||
            d.label.toLowerCase().includes("rear")
          );

          setCurrentCamera(back ? back.id : devices[0].id);
        }
      } catch (err) {
        console.error("Error obteniendo cámaras:", err);
        setLoadingCamera(false);
      }
    };

    initCamera();
  }, []);

  useEffect(() => {
    if (isRunning) return;
    if (!isIOS && !currentCamera) return;

    const startScanner = async () => {

      try {
        setLoadingCamera(true);
        hasScanned.current = false;
        if (!qrRef.current) {
          qrRef.current = new Html5Qrcode("reader");
        }

        const config = isIOS
          ? { facingMode: cameraMode }
          : { deviceId: { exact: currentCamera } };

        await qrRef.current.start(
          config,
          { fps: 10, qrbox: 250 },
          (decodedText) => {
            if (hasScanned.current) return;

            hasScanned.current = true;

            onScan(decodedText);
            stopScanner();
          }
        );

        setIsRunning(true);
        setLoadingCamera(false);

      } catch (err) {
        console.error("Error al iniciar cámara:", err);
        setLoadingCamera(false);
      }
    };

    startScanner();

    return () => {
      stopScanner();
    };

  }, [isIOS ? null : currentCamera]);

  useEffect(() => {
    
    if (!isIOS) return;
    if (!cameraMode) return;

    const restartScanner = async () => {
      try {
        if (qrRef.current && isRunning) {
          await qrRef.current.stop();
          setIsRunning(false);
        }

        setLoadingCamera(true);
        hasScanned.current = false;
        if (!qrRef.current) {
          qrRef.current = new Html5Qrcode("reader");
        }

        await qrRef.current.start(
          { facingMode: cameraMode },
          { fps: 10, qrbox: 250 },
          (decodedText) => {
            if (hasScanned.current) return;

            hasScanned.current = true;

            onScan(decodedText);
            stopScanner();
          }
        );

        setIsRunning(true);
        setLoadingCamera(false);

      } catch (err) {
        console.error("Error reiniciando cámara iOS:", err);
        setLoadingCamera(false);
      }
    };

    restartScanner();

  }, [cameraMode]);

  useEffect(() => {
    return () => {
      if (qrRef.current) {
        qrRef.current.stop().catch(() => {});
      }
    };
  }, []);

  const stopScanner = async () => {
    if (qrRef.current && isRunning) {
      try {
        await qrRef.current.stop();
        setIsRunning(false);
      } catch (e) {}
    }
  };

  const changeCamera = async (cameraId) => {
    if (qrRef.current && isRunning) {
      await stopScanner();
    }
    setCurrentCamera(cameraId);
  };

  const switchCameraIOS = () => {
    setCameraMode(prev =>
      prev === "environment" ? "user" : "environment"
    );
  };

  return (
    <div>

      {!isIOS && cameras.length > 0 && (
        <select
          className="camera-select"
          value={currentCamera || ""}
          onChange={(e) => changeCamera(e.target.value)}
        >
          {cameras.map(cam => (
            <option key={cam.id} value={cam.id}>
              {cam.label || "Cámara"}
            </option>
          ))}
        </select>
      )}

      {isIOS && (
        <button className="btn-switch-camera" onClick={switchCameraIOS}>
          Cambiar cámara
        </button>
      )}

      <div style={{ position: "relative", width: "100%", minHeight: "250px" }}>

        {loadingCamera && (
          <div className="qr-loading">
            <div className="spinner"></div>
            <span>
              {isIOS ? "Activando cámara..." : "Cargando cámara..."}
            </span>
          </div>
        )}

        <div
          id="reader"
          style={{
            width: "100%",
            height: "250px",
            opacity: loadingCamera ? 0 : 1,
            transition: "opacity 0.3s ease"
          }}
        />

      </div>

    </div>
  );
};